import { List, Theme } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import { ClassName } from 'types/ClassName';
import { uuid } from 'utils/uuidUtils';
import './DashboardList.scss';
import React, { ReactNode } from 'react';
import IIdable from 'types/Idable';

export interface IDashboardListRow<IdType extends string = string> {
  id: IdType;
  value: string;
  label: string;
}

export function getDefaultDashboardListRow(): IDashboardListRow {
  return { label: '---', value: '', id: uuid() };
}

export interface IDashboardListProps<T extends IIdable<IdType>, IdType extends string = string> {
  hover: boolean;
  renderItem: (item: T) => ReactNode;
  rowItems: T[];
  className?: ClassName;
  theme: Theme.DARK | Theme.LIGHT;
}

function DashboardList<T extends IIdable<IdType>, IdType extends string = string>({
  rowItems,
  className,
  hover,
  theme,
  renderItem,
}: IDashboardListProps<T, IdType>) {
  const classes = classNames('dashboard-list', theme, className);

  return (
    <List stroke={true} className={classes} hover={hover}>
      {rowItems.map((rowItem) => (
        <React.Fragment key={rowItem.id}>{renderItem(rowItem)}</React.Fragment>
      ))}
    </List>
  );
}

export default DashboardList;
